// @flow
import React from 'react';
import cx from 'classnames';

import './FakeBrandCard.scss';
import Brandpone from '../Brandpone/Brandpone';
import GrayBox from '../GrayBox';
import GrayBoxes from '../GrayBoxes';

// type GrayBoxProps = {
//   min: number,
//   max: number,
// };
//
// class GrayBox extends React.Component<GrayBoxProps> {
//   static defaultProps = {
//     min: 1,
//     max: 6,
//   };
//   size: number = 1;
//
//   constructor(props) {
//     super(props);
//     const { max, min } = this.props;
//     this.size = min + Math.random() * (max - min);
//   }
//
//   render() {
//     return <div className="gray-box keyframes blink" style={{ width: `${this.size}rem` }} />;
//   }
// }
//
// type GrayBoxesProps = {
//   count: number,
//   min?: number,
//   max?: number,
// };
//
// const GrayBoxes = ({ count, min, max }: GrayBoxesProps) => {
//   const array = Array.from(Array(count).keys());
//   return array.map(num => <GrayBox key={num} min={min} max={max} />);
// };

type Props = {
  oneColumn?: boolean,
};

const FakeBrandCard = ({ oneColumn }: Props) => (
  <Brandpone duration={100}>
    <div className={cx('BrandCard FakeBrandCard', { 'one-column': oneColumn })}>
      <div className="brand-card-link">
        <div className="brand-card-container">
          <div className="brand-image-wrapper">
            <div className="skeleton-image"></div>
          </div>
          <div className="brand-content">
            <div className="skeleton-title">
              <GrayBox min={4} max={8} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Brandpone>
);

FakeBrandCard.defaultProps = {
  oneColumn: false,
};

export default FakeBrandCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeBrandCard/FakeBrandCard.js